
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facts",
      function () {
        return require("private-next-pages/facts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facts"])
      });
    }
  